<template>
  <div>
    <ClientePolizaInfo @getData="$emit('getData')" :polizaInfo="polizaInfo" :clienteInfo="clienteInfo" />
    <ClienteContactoInfoIndex @getData="$emit('getData')" :polizaInfo="polizaInfo" :clienteInfo="clienteInfo" />
    <ClienteDomicilioInfoIndex @getData="$emit('getData')" :polizaInfo="polizaInfo" :clienteInfo="clienteInfo" />
  </div>
</template>

<script>
import ClienteContactoInfoIndex from "../ClienteData/ClienteSolcitud/ClienteContactoInfo/ClienteContactoInfoIndex.vue";
import ClientePolizaInfo from "../ClienteData/ClienteSolcitud/ClientePolizaInfo/ClientePolizaInfo.vue";
import ClienteDomicilioInfoIndex from "../ClienteData/ClienteSolcitud/ClienteDomicilioInfo/ClienteDomicilioInfoIndex.vue";
import { getClienteById } from "@/services/cliente/Clientes";

export default {
  components: {
    ClienteContactoInfoIndex,
    ClientePolizaInfo,
    ClienteDomicilioInfoIndex,
  },

  data() {
    return {
      clienteInfo: {}
    };
  },
  props: {
    polizaInfo: {
      type: Object,
      default: () => { },
    },
    productoInfo: {
      type: Object,
      default: () => { },
    },
  },
  watch: {
    'polizaInfo.cliente': {
      immediate: true,
      handler(clienteId) {
        if (!clienteId || clienteId == 0) return;
        getClienteById(clienteId).then((response) => {
          this.clienteInfo = response;
          if ((this.clienteInfo && this.productoInfo) && (this.clienteInfo.estadoCivil != null && (this.productoInfo.beneficiario === true || this.productoInfo.limiteFamiliares > 0))) {
            this.$toast.warning(
              'Para dar de alta a un beneficiario, es necesario contar con el estado civil completo del cliente.'
            );
          }
        });
      }
    }
  },
  methods: {},
};
</script>
